import {
  InsightsCombinedAnswerDto,
  InsightsCombinedAnswerModel,
  mapInsightsCombinedAnswerDtoToModel,
} from './InsightsAnswer.dto';
import { InsightsCombinedQuestionDto, InsightsCombinedQuestionModel } from './InsightsQuestion.dto';

export type InsightsCombinedItemDto = Readonly<{
  question: InsightsCombinedQuestionDto;
  answers: ReadonlyArray<InsightsCombinedAnswerDto>;
  // TODO: There is no respondentProtection field in the swagger definition. Review and cleanup if needed. https://buzzing.atlassian.net/browse/RPT-395
  respondentProtection?: boolean;
}>;

export type InsightsCombinedItemModel = Readonly<{
  question: InsightsCombinedQuestionModel;
  answers: ReadonlyArray<InsightsCombinedAnswerModel>;
  respondentProtection?: boolean;
}>;

export const mapInsightsItemDtoToModel = (
  dto: InsightsCombinedItemDto
): InsightsCombinedItemModel => ({
  question: dto.question,
  answers: dto.answers.map((answer) => mapInsightsCombinedAnswerDtoToModel(answer)),
  respondentProtection: !!dto.respondentProtection,
});
